$shm_hitalama_map_widget_panel $shm_hitalama_map_widget_float
	scrollable false
	content /
		<= Panel_body $mol_view
			style *
				alignSelf \flex-start
				width \fit-content
			sub <= controls /
	head_view /
	edges /
	outline /
	toolbar /
	auto /
		^
		<= size_sync null
	style *
		^
		contain \none
		overflow \visible
